"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const util_1 = require("../util");
const classDependentTypes_1 = require("../classDependentTypes");
const classDependentTypes_2 = require("../classDependentTypes");
const simple_1 = require("./simple");
/** Ascends a thing -> group -> group -> ... -> group -> groupDefiningType query.
 * This version will stop at the closest group defining type rather than continung groupDefiningType -> group -> ... -> group -> groupDefiningType
 * This version will also traverse thing -> group -> ... -> group -> partner -> partner group -> groupDefiningType, which happens with users
 * @param groupDefiningTypeId - The type of the thing you are ascending up to
 * @param sourceItemType - the start type of the query
 * @param addIdPrefixes - prefixes query ids with a string based on source and target type
 * @param finalSubQueries - Subqueries that will run on the groupDefiningType if it is found. This function actually returns the start of this query, so adding subqueries to it adds them to the wrong place.
 * @returns The apex query that can be used with sourceItem to perform the group nested ascending query
 * */
const getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef = ({ groupDefiningObjectTypeId, sourceItemType, addIdPrefixes = true, finalSubQueries = [], }) => {
    const idPrefix = addIdPrefixes ? `${sourceItemType}-${sourceItemType}-${iotv_v3_types_1.Traversal.ASCENDING}-` : '';
    // There are a rare few objects that go straight from themselves to customer (e.g. property). This query lets those objects to be inputs
    const sourceToDefiningTypeQuery = new util_1.BranchingQueryDefinition({
        id: `${idPrefix}sourceToDefiningTypeQuery`,
        path: [
            {
                objectTypeId: groupDefiningObjectTypeId,
                adjacencyType: iotv_v3_types_1.AdjacentType.PARENT,
                edgeTypeId: (0, classDependentTypes_1.getParentEdgeTypeId)(sourceItemType, groupDefiningObjectTypeId),
            },
        ],
        subQueries: finalSubQueries,
    });
    const groupToGroupDefiningTypeQuery = new util_1.BranchingQueryDefinition({
        id: `${idPrefix}groupToGroupDefiningTypeQuery`,
        path: [
            { objectTypeId: groupDefiningObjectTypeId, adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: (0, classDependentTypes_1.getParentEdgeTypeId)('Group', groupDefiningObjectTypeId) },
        ],
        subQueries: finalSubQueries,
    });
    /** WARN: Theoretically there should be no partner groups but this one, however, if you start nesting partner groups, you'll need to update this query. */
    const partnerGroupToDefiningTypeQuery = (0, simple_1.getSimpleBranchingQuery)('Group', groupDefiningObjectTypeId, iotv_v3_types_1.AdjacentType.PARENT);
    const partnerToGroupQuery = (0, simple_1.getSimpleBranchingQuery)('Partner', 'Group', iotv_v3_types_1.AdjacentType.PARENT);
    partnerToGroupQuery.addSubQuery(partnerGroupToDefiningTypeQuery);
    const groupToPartnerQuery = (0, simple_1.getSimpleBranchingQuery)('Group', 'Partner', iotv_v3_types_1.AdjacentType.PARENT);
    groupToPartnerQuery.addSubQuery(partnerToGroupQuery);
    const groupToGroupQuery = new util_1.BranchingQueryDefinition({
        id: `${idPrefix}groupToGroupQuery`,
        path: [{ objectTypeId: 'Group', adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: classDependentTypes_2.edgeTypeMatrix.Group.Group.group_has_subGroup.edgeTypeId }],
        subQueries: [groupToGroupDefiningTypeQuery, groupToPartnerQuery],
    });
    groupToGroupQuery.addSubQuery(groupToGroupQuery);
    const itemsToGroupQuery = new util_1.BranchingQueryDefinition({
        path: [{ objectTypeId: 'Group', adjacencyType: iotv_v3_types_1.AdjacentType.PARENT, edgeTypeId: (0, classDependentTypes_1.getParentEdgeTypeId)(sourceItemType, 'Group') }],
        subQueries: [groupToGroupDefiningTypeQuery, groupToGroupQuery, groupToPartnerQuery],
        id: `${idPrefix}itemsToGroup`,
    });
    // Start with myself so the source can be a group too
    const closestAscendingApexQuery = new util_1.BranchingQueryDefinition({
        id: `${idPrefix}itemTypeToGroupNestedAscendingQueryBase`,
        path: [{ objectTypeId: sourceItemType, adjacencyType: iotv_v3_types_1.AdjacentType.SUBJECT }],
        subQueries: [itemsToGroupQuery, groupToGroupQuery, groupToGroupDefiningTypeQuery, sourceToDefiningTypeQuery, groupToPartnerQuery],
    });
    return closestAscendingApexQuery;
};
exports.getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef = getClosestPartnerInclusiveItemTypeToGroupNestedAscendingQueryDef;
